import React from 'react'
import { withIcon } from '../../withIcon'

function ClockIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path fillRule="evenodd" clipRule="evenodd" d="M12 4.125C7.37462 4.125 3.625 7.87462 3.625 12.5C3.625 17.1254 7.37462 20.875 12 20.875C16.6254 20.875 20.375 17.1254 20.375 12.5C20.375 7.87462 16.6254 4.125 12 4.125ZM2.375 12.5C2.375 7.18426 6.68426 2.875 12 2.875C17.3157 2.875 21.625 7.18426 21.625 12.5C21.625 17.8157 17.3157 22.125 12 22.125C6.68426 22.125 2.375 17.8157 2.375 12.5ZM12 6.875C12.3452 6.875 12.625 7.15482 12.625 7.5V12.2411L15.4419 15.0581C15.686 15.3021 15.686 15.6979 15.4419 15.9419C15.1979 16.186 14.8021 16.186 14.5581 15.9419L11.5581 12.9419C11.4408 12.8247 11.375 12.6658 11.375 12.5V7.5C11.375 7.15482 11.6548 6.875 12 6.875Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ClockIcon)
